export default "__VITE_ASSET__eybpTmC4__"